import { HttpClient } from '../httpClient';
import GendersResponse from '../responses/gendersResponse';

const httpClient = new HttpClient();

export const getGenders = async () => {
  return httpClient.get<GendersResponse>({
    url: '/v1/genders',
    requiresToken: true,
  });
};
